export const faqs = [
  [
    'Is this a physical product?',
    'No. Complete Sports Massage Bundle is a 100% digital product. You receive access to the professional resources electronically.',
  ],
  [
    'Who is this system designed for?',
    'It is designed for qualified sports massage therapists, therapeutic massage practitioners, manual therapy professionals, and other appropriately trained professionals who incorporate massage into their practice.',
  ],
  [
    'Do I need previous massage training?',
    'Yes. This is a professional reference system, not a beginner certification or a substitute for supervised practical training.',
  ],
  [
    'Are step-by-step massage techniques included?',
    'Yes. The lower-body and upper-body volumes are structured around regional techniques, positioning, contact guidance, practical sequences, and adaptations.',
  ],
  [
    'Are treatment durations included?',
    'Yes. The system includes example application times and complete 30-, 45-, and 60-minute session formats. These are adaptable examples, not mandatory clinical prescriptions.',
  ],
  [
    'Are complete sessions included?',
    'Yes. Volume 5 contains complete massage session examples organized by sport. Volume 4 provides event-based protocols for pre-event, post-event, and maintenance contexts.',
  ],
  ['Are the five bonuses included?', 'Yes. All five practical bonuses are included as part of the complete digital bundle.'],
  [
    'How do I receive the product?',
    'After your payment is confirmed, access instructions are delivered digitally through the purchase process.',
  ],
  ['Is this a subscription?', 'No. It is a one-time payment of $26.90 USD, not a recurring subscription.'],
  [
    'Does this replace professional massage training or medical care?',
    'No. The material is intended for appropriately qualified professionals and does not replace hands-on training, clinical assessment, diagnosis, professional licensing requirements, or individualized medical care.',
  ],
] as const
